import { useQuery } from "@tanstack/react-query";
import { WiMuleSQL } from "../../services/WiMuleSQL";

export const useGetActiveFaults = () => {
  const fetchActiveFaults = async () => {
    const response = await fetch(`${WiMuleSQL}/api/ActiveFaults/GetOutdated`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.status === 204) {
      return { noContent: true };
    }

    if (!response.ok) {
      throw new Error(`Active Faults HTTP Error: ${response.status}`);
    }

    return response.json();
  };

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["getActiveFaults"],
    queryFn: fetchActiveFaults,
    enabled: true,
    refetchInterval: 60 * 1000,
  });

  return { data, isLoading, isError, error, refetch };
};
